// extracted by mini-css-extract-plugin
export default {"account":"Account_account__pw3HK","text":"Account_text__7z+-m","logout":"Account_logout__0rzOr","container":"Account_container__eW8GW"};